import { APIClient } from './APIClient'

export const fetchSettings = () => {
    return APIClient.get(`/v1/en/settings`)
}
